import { createContext, ReactNode } from 'react';

import useFeatureFlags from './hooks/useFeatureFlags';

export const FeatureFlagsContext = createContext<Record<string, boolean>>({});

export const FeatureFlagsProvider = ({ children }: { children: ReactNode }) => {
  const { featureFlags } = useFeatureFlags();

  return (
    <FeatureFlagsContext.Provider value={featureFlags}>{children}</FeatureFlagsContext.Provider>
  );
};
